
import { Component } from '@angular/core';
import { RestorerStats, SeagrassRestorerService } from '@spotter/services/restorer/seagrass-restorer.service';
import { LogoSliderComponent } from '../../shared/logo-slider/logo-slider.component';
import { FrontPageWidget } from '@spottercomponents/widgets/front-page/front-page.widget'
import { SEOService } from '@spotter/services/internal/seo-service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-home',
    templateUrl: './home.page.html',
    styleUrl: './home.page.scss',
    imports: [LogoSliderComponent, FrontPageWidget, TranslatePipe]
})
export class HomePage {

    stats?: RestorerStats;

    logos: string[] = [
        '/assets/images/logos/founding-partners/groningen.png',
        '/assets/images/logos/founding-partners/dalhouse.png',
        '/assets/images/logos/founding-partners/deakin.png',
        '/assets/images/logos/founding-partners/swansea.png',
        '/assets/images/logos/founding-partners/stellenbosch.png',
        '/assets/images/logos/founding-partners/ualg.png',
        '/assets/images/logos/founding-partners/aveiro.png',
        '/assets/images/logos/founding-partners/gothenburg.png',
        '/assets/images/logos/founding-partners/ps.png',
        '/assets/images/logos/founding-partners/cq.png',
        '/assets/images/logos/founding-partners/hu.png',
    ];

    constructor(restorer: SeagrassRestorerService, private seo: SEOService) {
        restorer.stats().then(s => {
            this.stats = s;
            console.log(s);

        });
    }

    ngOnInit() {
        this.seo.setTitle("Home");
        this.seo.setDescription("Discover seagrass meadow restoration efforts from around the world with our interactive map and database. Explore restoration project locations, contribute your own sightings, and access data for research and conservation efforts.");
    }

}
